import request from '@/utils/request'

export default {
    fetchProducts(afm) {
        return request.get(`/products/afm/${afm}`)
    }
}
